'use client'

import { createContext, useContext, useState, ReactNode, useCallback } from 'react'

interface PageHeaderContextType {
  title: string
  subtitle?: string
  actions?: ReactNode
  setPageHeader: (title: string, subtitle?: string, actions?: ReactNode) => void
}

const PageHeaderContext = createContext<PageHeaderContextType | undefined>(undefined)

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState('')
  const [subtitle, setSubtitle] = useState<string | undefined>()
  const [actions, setActions] = useState<ReactNode | undefined>()

  // Memoize setPageHeader to prevent infinite loops
  const setPageHeader = useCallback((newTitle: string, newSubtitle?: string, newActions?: ReactNode) => {
    setTitle(newTitle)
    setSubtitle(newSubtitle)
    setActions(newActions)
  }, [])

  return (
    <PageHeaderContext.Provider value={{ title, subtitle, actions, setPageHeader }}>
      {children}
    </PageHeaderContext.Provider>
  )
}

export function usePageHeader() {
  const context = useContext(PageHeaderContext)
  if (context === undefined) {
    throw new Error('usePageHeader must be used within a PageHeaderProvider')
  }
  return context
}


